<template>
    <AdditionalDescriptionEdit 
        :entity-type="BUSINESS_TYPE.RESTAURANT"
        :entity-id="+$route.params.id"
        :category-id="+$route.params.category_id">
        <template v-slot:tabs>
            <RestaurantsTabLinks />
        </template>
    </AdditionalDescriptionEdit>
</template>

<script>
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import AdditionalDescriptionEdit from '@/components/additional-description/AdditionalDescriptionEdit';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'RestaurantAdditionalDescriptionEdit',

        components: {
            RestaurantsTabLinks,
            AdditionalDescriptionEdit
        },
  
        data () {
            return {
                BUSINESS_TYPE
            }
        },
    
        computed: {},

        mounted() {},

        methods: {}
    }
</script>
